export const isOspTurbine = (name) => {
    const OSPcatcher = /^OSP.?$/;
    const isOspCatched = OSPcatcher.test(name);
    return isOspCatched;
};
export const getLastChar = (name) => name.charAt(name.length - 1);

export const isRealTurbine = (item) => item.substation.length > 0;

export const convertNameToSortNumber = (name) => {
    const digits = name.split('');
    let numericName = [];
    if (digits) {
        digits.forEach((digit, i) => {
            switch (typeof digit) {
                case 'number':
                    numericName[i] = Number(digit);
                    break;
                case 'string':
                    numericName[i] = digit.charCodeAt(0);
                    break;
                default:
                    numericName[i] = 0;
            }
        });
    }
    return -numericName.join('');
};
